export default __webpack_public_path__ + "static/media/tux.ff969ad1.svg";